/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ThreeDotsMenu/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import DropdownOptions from 'DesignSystem/DropdownOptions/index'
import React from 'react'
import ThreeDots from 'DesignSystem/Svgs/ThreeDots/index'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'
import TysiaIconMoreHoriz from 'DesignSystem/Svgs/TysiaIconMoreHoriz/index'
import Warning from 'DesignSystem/Svgs/Warning/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function ThreeDotsMenu({
  children,
  viewPath = "/DesignSystem/ThreeDotsMenu",
  marginLeft = 0,
  marginRight = 0,
  marginTop = 0,
  marginBottom = 0,
  alignSelf = "stretch",
  valueWidth,
  dropdownRef,
  toggleIsShowing,
  isVerticalDots,
  iconColor,
  isShowingWarning,
  isShowing,
  field = "text",
  from,
  onClick,
  isSelected,
  height = 300,
  width,
  top = 32,
  right,
  left,
  transformOriginY,
  isMultiChoice
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<div
  data-testid="ThreeDotsMenu.Vertical"
  data-view-path={viewPath}
 style={{'--ml-1-ZwF2gG': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-2-ZwF2gG': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--mt-3-ZwF2gG': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-4-ZwF2gG': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--as-5-ZwF2gG': alignSelf}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="ThreeDotsMenu.Vertical:1"
  data-view-path={viewPath}
 ref={dropdownRef}
 style={{'--as-5-ZwF2gG': alignSelf,'--w-6-ZwF2gG': typeof valueWidth === 'number' ? `${valueWidth}px` : valueWidth}}
 className={`views-block ${styles.Vertical1}`}
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="ghost"
 size="small"
 onClick={toggleIsShowing}
>
{childProps => (
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<React.Fragment>
<fromFlow.When is={!isVerticalDots}>
<TysiaIconMoreHoriz
{...childProps}
  viewPath={`${viewPath}/TysiaIconMoreHoriz`}
 fill={iconColor}
 width={dtSpaceS}
 height={dtSpaceS}
/>
</fromFlow.When>
<fromFlow.When is={isVerticalDots}>
<ThreeDots
{...childProps}
  viewPath={`${viewPath}/ThreeDots`}
 fill={iconColor}
 width={dtSpaceS}
 height={dtSpaceS}
/>
</fromFlow.When>
</React.Fragment>
)}
</TysiaButtonIcon>
)}
</TysiaButton>
<fromFlow.When is={isShowingWarning}>
<div
  data-testid="ThreeDotsMenu.Vertical:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical2}`}
>
<Warning
  viewPath={`${viewPath}/Warning`}
 stroke="#ff6f00"
/>
</div>
</fromFlow.When>
<fromFlow.When is={isShowing}>
<DropdownOptions
  viewPath={`${viewPath}/DropdownOptions`}
 field={field}
 from={from}
 onClick={onClick}
 isSelected={isSelected}
 height={height}
 width={width}
 top={top}
 right={right}
 left={left}
 transformOriginY={transformOriginY}
 isMultiChoice={isMultiChoice}
/>
</fromFlow.When>
</div>
</div>
{children}
</React.Fragment>)
}